import axiosInstance from "../lib/axios";

interface GetProjectRequest {
  page?: number;
  limit?: number;
}

export const getProject = async ({
  page = 1,
  limit = 10,
}: GetProjectRequest) => {
  const body = {
    page,
    limit,
  };

  const { data } = await axiosInstance.post("/Project/List", body);

  return data;
};



export const getProjectById = (id: number) => {
  return axiosInstance.get(`/Project/${id}`);
};



